import React from 'react';
import mappedIcon from '../../../../assets/images/mappedicon.svg';

interface BackstockStatusMetricProps {
  packs: number | string | null | undefined;
  tickets?: number | string | null | undefined;
  onPackClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  packTitle?: string;
}

const toNumber = (value: number | string | null | undefined): number => {
  const parsed = Number(value ?? 0);
  return Number.isFinite(parsed) ? parsed : 0;
};

const BackstockStatusMetric: React.FC<BackstockStatusMetricProps> = ({
  packs,
  tickets,
  onPackClick,
  packTitle,
}) => {
  const packCount = toNumber(packs);
  const ticketCount = toNumber(tickets);

  if (packCount <= 0) {
    return (
      <div className="audit-table__backstock-status audit-table__backstock-status--clear">
        <img src={mappedIcon} alt="Backstock clear" className="audit-table__backstock-status-icon" />
        <span className="audit-table__backstock-status-zero">0</span>
      </div>
    );
  }

  const packLabel = `${packCount.toLocaleString()} ${packCount === 1 ? 'pack' : 'packs'}`;
  const content = (
    <>
      <span className="audit-table__backstock-status-count">{packLabel}</span>
      {ticketCount > 0 && (
        <span className="audit-table__backstock-status-subtext">
          {ticketCount.toLocaleString()} tickets
        </span>
      )}
    </>
  );

  if (onPackClick) {
    return (
      <button
        type="button"
        className="audit-table__backstock-status audit-table__backstock-status--alert audit-table__backstock-status--link"
        onClick={onPackClick}
        title={packTitle ?? 'Activated or settled packs LottoReco still believes are in backstock and outside audited inventory'}
      >
        {content}
      </button>
    );
  }

  return (
    <div className="audit-table__backstock-status audit-table__backstock-status--alert">
      {content}
    </div>
  );
};

export default BackstockStatusMetric;
